import axios from "../plugins/parseAxios";
export class BankAccountAPI {
  constructor(props) {}
  static createBankAccount(postData) {
    return axios.post("functions/createBankAccount", postData);
  }
  static getBankAccounts(projectId) {
    return axios.post("functions/getBankAccounts", {projectId});
  }
  static updateBankAccount(postData) {
    return axios.post("functions/updateBankAccount", postData);
  }
  static removeBankAccount(bankAccountId) {
    return axios.post("functions/removeBankAccount", {id: bankAccountId});
  }
}
